

import React, { Component } from 'react';
import './about.scss'

class About extends Component {
  render() {
    return (
      <div className='about-page-container'>
        <div className='about-page-image'></div>
        <div className='about-page-content-container'>
        <p>
            Bob's Burgers is a third generation burger joint off Ocean Ave in New Jersey, just a few miles from the famous Wonder Warf. We make classic burgers with a twist. If you want to experience a great burger in an okay setting, come visit us! 
        </p></div>
      </div>
    )
  }
}

export default About
